export default {
  gridcontextmenu: {
    gridContextMenuModal: {
      header: "Вигляд",
      menu: {
        full: "Повний",
        optimal: "Оптимальний",
        load: "Завантажити мої налаштування",
        save: "Зберегти мої налаштування"
      },
      stateApplied: {
        loadSuccess: "Налаштування успішно завантажені",
        saveSuccess: "Налаштування успішно збережено",
        loadError: "Немає збережених налаштувань"
      }
    }
  }
};
